import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import api from '../../services/api.ts';
import { formatCurrency } from '../../utils/currency.ts';
import FormPage from '../../components/ui/FormPage.tsx';

const DesconciliarOfx: React.FC = () => {
  const { txId } = useParams<{ txId: string }>();
  const navigate = useNavigate();
  const [note, setNote] = useState('');
  const [error, setError] = useState('');

  const { data, isLoading } = useQuery(
    ['ofx-tx', txId],
    async () => {
      const res = await api.get(`/financeiro/conciliacao-ofx/${txId}`);
      return res.data as any;
    },
    { enabled: !!txId }
  );

  const mutation = useMutation(
    async () => {
      const res = await api.post(`/financeiro/conciliacao-ofx/${txId}/desconciliar`, { note });
      return res.data;
    },
    {
      onSuccess: () => navigate('/financeiro/conciliacao-ofx'),
      onError: (err: any) => setError(err?.response?.data?.error || 'Erro ao desconciliar'),
    }
  );

  if (isLoading || !data) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-500" />
      </div>
    );
  }

  return (
    <FormPage
      backTo="/financeiro/conciliacao-ofx"
      backLabel="Voltar ao extrato"
      breadcrumb="Financeiro / Conciliação OFX / Desconciliar"
      title="Desconciliar transação"
      subtitle="Remove o vínculo · não apaga o lançamento do fluxo"
      hint={`Auditoria obrigatória · FITID ${data.fitid} · ${data.lcCode || 'sem LC'}`}
      footer={
        <>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => navigate('/financeiro/conciliacao-ofx')}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-primary"
            disabled={!note.trim() || mutation.isLoading}
            onClick={() => {
              setError('');
              mutation.mutate();
            }}
          >
            {mutation.isLoading ? 'Confirmando…' : 'Confirmar desconciliação'}
          </button>
        </>
      }
    >
      {error && <div className="field-error" style={{ marginBottom: 12 }}>{error}</div>}

      <div className="summary-panel" style={{ marginBottom: 20 }}>
        <div className="summary-row">
          <span>Descrição</span>
          <strong>{data.description}</strong>
        </div>
        <div className="summary-row">
          <span>Valor</span>
          <strong>{formatCurrency(data.amount)}</strong>
        </div>
        <div className="summary-row">
          <span>Lançamento</span>
          <strong>{data.lcCode || '—'}</strong>
        </div>
        <div className="summary-row">
          <span>FITID</span>
          <strong className="mono">{data.fitid}</strong>
        </div>
      </div>

      <label className="field full">
        <span>Nota de auditoria *</span>
        <textarea
          className="input"
          rows={3}
          value={note}
          onChange={e => setNote(e.target.value)}
          placeholder="Motivo curto da desconciliação"
          required
        />
      </label>
    </FormPage>
  );
};

export default DesconciliarOfx;
